import React, { useState } from "react";
import BackButton from "../components/BackButton";
import AuthentifiedPage from "./AuthentifiedPage";
import CollecteSuccessMessage from "../components/CollecteSuccessMessage";
import CollecteErrorMessage from "../components/CollecteErrorMessage";
import "../styles/CollectDataPage.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import CollectDataTable from "../components/CollectDataTable";
import { DynamicField } from "../types/DynamicField";

export interface CollectEntry {
  id: string;
  culture: string;
  superficie: number; // hectares
  rendement: number; // kg/ha
  productionTotale: number; // kg
  submittedAt: string;
}

export interface CollectField {
  key: keyof CollectEntry;
  label: string;
  section: string;
  type: "text" | "number" | "select";
}

// ----------------------
// SCHEMA DES CHAMPS (tableau)
// ----------------------
const sampleSchema: DynamicField[] = [];

// ----------------------
// DONNÉES STATIQUES INITIALES
// ----------------------
const sampleEntries: Map<string,any>[] = [];

const DocumentDetailsTechnicien: React.FC = () => {
  const [submissions] = useState<Map<string,any>[]>(sampleEntries);
  const [successVisible, setSuccessVisible] = useState(false);
  const [errorVisible, setErrorVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("Données téléchargées");
  const [errorMessage, setErrorMessage] = useState("Une erreur est survenue");

  // ----------------------
  // Actions
  // ----------------------
  const handleExportData = () => {
    if (submissions.length === 0) {
      setErrorMessage("Aucune donnée à exporter");
      setErrorVisible(true);
      setTimeout(() => setErrorVisible(false), 1500);
      return;
    }
    setSuccessMessage("Données téléchargées avec succès");
    setSuccessVisible(true);
    setTimeout(() => setSuccessVisible(false), 1500);
  };

  const handleRetourner = () => {
    setSuccessMessage("Document retourné pour correction");
    setSuccessVisible(true);
    setTimeout(() => setSuccessVisible(false), 1500);
  };

  const handleValider = () => {
    setSuccessMessage("Collecte validée avec succès");
    setSuccessVisible(true);
    setTimeout(() => setSuccessVisible(false), 1500);
  };

  return (
    <AuthentifiedPage
      leftButtons={[
        { text: "Retourner à corriger", color: "red", onClick: handleRetourner },
      ]}
      rightButton={{
        text: "Valider les données",
        color: "green",
        onClick: handleValider,
      }}
    >
      <main className="container py-4 flex-grow-1">
        <BackButton text="Retour" />

        <h4 className="mt-3">Détails - Collecte de Rendements Agricoles</h4>
        <CollecteSuccessMessage visible={successVisible} message={successMessage} />
        <CollecteErrorMessage visible={errorVisible} message={errorMessage} />

        {/* Table des données */}
        <div className="mt-4">
          <CollectDataTable schema={sampleSchema} data={submissions} />
        </div>
      </main>
    </AuthentifiedPage>
  );
};

export default DocumentDetailsTechnicien;
